import {
  FaGraduationCap,
  FaGlobe,
  FaBolt,
  FaTools,
  FaProjectDiagram,
  FaChalkboardTeacher,
  FaMoneyBillWave,
  FaCheckCircle,
  FaUserShield,
  FaVideo,
  FaLightbulb,
} from "react-icons/fa";
import "../styles/learning-path.css";
import TestimonialVideo from "../components/TestimonialVideo";

const learningPathSections = [
  {
    icon: FaTools,
    title: "THỰC CHIẾN TẠI DOANH NGHIỆP",
    items: [
      "Làm thật trong môi trường thật với dự án từ doanh nghiệp",
      "Rèn luyện kỹ năng, xây dựng nền tảng nghề nghiệp thực tế",
    ],
  },
  {
    icon: FaGlobe,
    title: "THAM GIA LINH HOẠT - DÙ BẠN Ở BẤT CỨ ĐÂU",
    items: [
      "Online từ xa: Dành cho sinh viên tỉnh xa, du học sinh, người bận rộn",
      "Trực tiếp: Học tại phim trường, studio, doanh nghiệp liên kết",
      "Cả hai hình thức đều hỗ trợ sát sao 1:1, đảm bảo chất lượng",
    ],
  },
  {
    icon: FaChalkboardTeacher,
    title: "ĐƯỢC HUẤN LUYỆN BỞI CHUYÊN GIA HÀNG ĐẦU",
    items: [
      "Giảng dạy bởi CEO, Giám đốc sáng tạo, giảng viên lâu năm",
      "Truyền nghề thực thụ qua mỗi buổi học – không lý thuyết suông",
    ],
  },
  {
    icon: FaMoneyBillWave,
    title: "THỰC CHIẾN - NHẬN LƯƠNG - CÓ VIỆC LÀM",
    items: [
      "Nhận lương từ chính sản phẩm bạn thực hiện",
      "Cam kết 100% có việc làm hoặc trở thành freelancer chuyên nghiệp",
      "Kết nối với đối tác tuyển dụng sau khóa học",
    ],
  },
  {
    icon: FaProjectDiagram,
    title: "NỘI DUNG THỰC CHIẾN TIÊU BIỂU",
    items: [
      "Quay – chụp ảnh sản phẩm bằng smartphone chuẩn truyền thông",
      "Thiết kế ấn phẩm – viết kịch bản – dựng phim quảng cáo",
      "Vận hành kênh truyền hình online chỉ với 1 người",
      "Thực hành trên thiết bị ảo, studio, công nghệ đồ họa 3D",
      "Dự án nhóm mô phỏng agency/studio chuyên nghiệp",
    ],
  },
  {
    icon: FaUserShield,
    title: "RÈN KỸ NĂNG CỨNG & MỀM TOÀN DIỆN",
    items: [
      "Giao tiếp – phản biện – teamwork chuyên nghiệp",
      "Thuyết trình ý tưởng, trình bày sản phẩm, làm việc với khách hàng",
      "Quản lý thời gian, dự án cá nhân",
      "Làm việc dưới áp lực và xử lý tình huống linh hoạt",
    ],
  },
  {
    icon: FaLightbulb,
    title: "THÀNH QUẢ SAU KHÓA HỌC",
    items: [
      "Chứng nhận thực tập không thời hạn từ doanh nghiệp",
      "Portfolio cá nhân với sản phẩm thật",
      "Kết nối tuyển dụng, phát triển freelance hoặc startup cá nhân",
      "Được cố vấn 1:1 sau khoá học để định hướng nghề nghiệp",
    ],
  },
  {
    icon: FaVideo,
    title: "THÔNG TIN CHƯƠNG TRÌNH",
    items: [
      "Thời gian: 8–12 tuần (theo đợt đăng ký)",
      "Hình thức: Online từ xa & Offline tại TP.HCM",
      "Đối tượng: Sinh viên năm 2+ hoặc đã tốt nghiệp các ngành Thiết kế, Truyền thông, Marketing, Media",
    ],
  },
  {
    icon: FaBolt,
    title: "ĐĂNG KÝ NGAY – GIỚI HẠN 20 SUẤT ĐẦU",
    items: [
      "Inbox fanpage hoặc gọi Hotline học viện Design24",
      "Ưu tiên 20 suất đầu tiên được học bổng hỗ trợ 30–50%",
    ],
  },
];

const LearningPath = () => {
  return (
    <section className="learning-path">
      <div className="learning-path__overlay" />
      <div className="learning-path__content">
        <h1 className="learning-path__title">
          <FaGraduationCap className="learning-path__title-icon" />
          HỌC KỲ THỰC CHIẾN DOANH NGHIỆP
        </h1>

        <p className="learning-path__subtitle">
          Dành cho sinh viên Thiết kế, Truyền thông, Marketing, Kinh doanh và
          các ngành có nhu cầu.
          <br />
          Trải nghiệm thực chiến – Nhận lương – Cam kết việc làm – Học online
          hoặc trực tiếp!
        </p>
        <div className="learning-path__testimonials">
          <h2 className="learning-path__testimonials-title">
            Cảm nhận của sinh viên tham gia học kỳ <br />
            thực chiến doanh nghiệp
            <div className="line"></div>
          </h2>

          <div className="learning-path__testimonials-grid">
            {["k1qmvx_vLjE", "erKju6N99qk", "Kn5gSNOrBHg", "jTZ5zzYvskk"].map(
              (videoId, index) => (
                <TestimonialVideo
                  key={index}
                  videoId={videoId}
                />
              )
            )}
          </div>
        </div>

        <div className="learning-path__cards">
          {learningPathSections.map((section, index) => {
            const Icon = section.icon;
            return (
              <div
                key={index}
                className="learning-path__card"
              >
                <h2 className="learning-path__card-title">
                  <Icon className="learning-path__card-title-icon" />
                  {section.title}
                </h2>
                <ul className="learning-path__card-list">
                  {section.items.map((item, i) => (
                    <li key={i}>
                      <FaCheckCircle /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <p className="learning-path__subtitle">
          Học viện Design24 cam kết đồng hành cùng bạn trên hành trình trở thành
          chuyên gia thực chiến.
          <br />
          Tham gia ngay để biến kỹ năng thành giá trị thực – Từ sinh viên thành
          người làm nghề!
        </p>
      </div>
    </section>
  );
};

export default LearningPath;
